










































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

type PropType = {
  name: string,
  title: string,
  value?: string | number,
  class?: string,
  link?: string,
  icon?: string,
}

@Component
export default class TabularHeader extends Vue {
  @Prop() columns!: PropType[]

  @Prop({
    default: 'tes-gradient-navy-blue-none-hover'
  }) bgColor!: string

  @Prop({
    default: 'text-tes-grey-blue-dark'
  }) titleClass!: string

  @Prop({
    default: 'text-white'
  }) valueClass!: string

  @Prop({ type: String, default: 'center' }) alignItems: string

  get getAlignItemsClass() {
    switch (this.alignItems) {
      case 'start':
        return 'items-start'
      case 'end':
        return 'items-end'
      default:
        return 'items-center'
    }
  }

  get hasDefaultSlot() {
    return !!this.$scopedSlots.default
  }

  get innerSlotClass() {
    if (this.hasDefaultSlot) {
      return 'col-10'
    } else {
      return 'col-12'
    }
  }

  get cageBg() {
    return `bg-${this.bgColor}`
  }

  get cageClass() {
    if (this.$q.screen.lt.md) {
      return 'column reverse q-px-md'
    } else if (this.$q.screen.lt.lg) {
      return 'row q-px-lg border-radius-8'
    } else {
      return 'row q-px-lg border-radius-8'
    }
  }

  get itemClass() {
    if (this.$q.screen.lt.md) {
      return 'row justify-between col-12'
    } else {
      return 'justify-center'
    }
  }

  get actionsClasses() {
    return this.$q.screen.lt.md ? 'full-width justify-center' : 'col-2 justify-end'
  }
}
